$(document).ready(function() {
  console.log("Z-COLLECTION FILE LOADED");

    $(".dm_main_collection_product").each(function(i) {
        if ($(this).find(".dm_main_product_value .swiper-wrapper div").length != 0) {
            let src = $(this).find(".dm_main_product_value input:checked").next().find("img:first-child").attr("src");
            $(this).find(".dm_main_product_image img ").attr("src", src)

        }
    })
    $("body").on("click", "#ProductGridContainer .z_main_product_button_size", function() {
        let selected_var = $(this).closest(".dm_main_collection_product").find(".dm_main_product_value_input:checked").attr("option-value");
        let tthiss = $(this).closest(".dm_main_collection_product");

        const options_arr = $(this).closest(".dm_main_collection_product").find(".dm_products_size_value_option");
        const selected_size_options = $(this).closest(".dm_main_collection_product");
        const url_product = selected_size_options.data('product-url');
        const product_id = selected_size_options.data('product-id');

        const inventoryJSONElement = $(this).closest(".dm_main_collection_product").find(".custom_variant_quantity--" + product_id);
        const inventoryJSON = $.parseJSON(inventoryJSONElement.text());

        const bottom_option_arr = $(`.z_product_drawer .dm_products_size[data-product-id="${product_id}"] .dm_products_size_value .dm_products_size_value_option`);

        bottom_option_arr.each(function() {
            let size_path = $(this);
            let sizee = $(this).find(".dm_products_size_value_name").text();
            let temp_val = $.trim(selected_var) + " / " + $.trim(sizee);

            const inventory_details = inventoryJSON[temp_val];
            const inventory = parseInt(inventory_details.inventory);
          const available = inventory_details.available;
            const option_label_element = $(this).find('.z_products_size_value_label');
            const status_element = $(this).find(".dm_products_size_value_status");
            const notify_element = $(this).find('.dm_products_size_value_notice');

            if (inventory < 5 && inventory > 0) {
                $(notify_element).text(`Hurry, only ${inventory} left`);
            } else {
                $(notify_element).text("");
            }

            if (!available && inventory === 0) {
                $(status_element).text("Out of Stock");
                $(option_label_element).parent('.dm_products_size_value_option').addClass("dm_product_main_sold_out");
            } else {
                $(status_element).text("Available");
                $(option_label_element).parent('.dm_products_size_value_option').removeClass("dm_product_main_sold_out");
            }


        });

        options_arr.each(function() {

            let size_path = $(this);
            let sizee = $(this).find(".dm_products_size_value_name").text();
            let temp_val = selected_var + " / " + sizee;

            tthiss.find(".dm_product_variants .dm_swatch option").each(function(i) {
                if ($(this).text().trim() == temp_val) {
                    if ($(this).attr("data-policy") == 'deny' && $(this).attr("data-size") <= 0) {
                        size_path.find("label").css("pointer-events", "none");
                        size_path.find(".dm_products_size_value_label_parent").addClass("z_product_ui_option_un");
                        size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Sold out");

                    } else {
                        size_path.find("label").css("pointer-events", "all");
                        size_path.find(".dm_products_size_value_label_parent").removeClass("z_product_ui_option_un");
                        size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Available")
                    }
                }
            })
        })
        // $("body").addClass("dm_products_size_hidden");
        const targetDiv = $(this).closest(".dm_main_collection_product").find(".dm_main_product");
        const productId = targetDiv.attr("product-handle");

        $(this).closest(".dm_main_collection_product").find(".dm_products_size_overlay").addClass("dm_products_size_overlay_e");
        $(this).closest(".dm_main_collection_product").find(".dm_products_size").addClass("z_open");

    })

    $("body").on("change", "#ProductGridContainer .dm_main_product_value_input", function() {
      console.log("Yeppi")
        let selected_var = $(this).closest(".dm_main_collection_product").find(".dm_main_product_value_input:checked").attr("option-value");

        let tthiss = $(this).closest(".dm_main_collection_product");

      const selected_size_options = $(this).closest(".dm_main_collection_product")
        const url_product = selected_size_options.data('product-url');
        const product_id = selected_size_options.data('product-id');

        const inventoryJSONElement = $(this).closest(".dm_main_collection_product").find(".custom_variant_quantity--" + product_id);
        const inventoryJSON = $.parseJSON(inventoryJSONElement.text());

        const bottom_option_arr = $(`.z_product_drawer .dm_products_size[data-product-id="${product_id}"] .dm_products_size_value .dm_products_size_value_option`);

      
        bottom_option_arr.each(function() {
            let size_path = $(this);
            let sizee = $(this).find(".dm_products_size_value_name").text();
            let temp_val = $.trim(selected_var) + " / " + $.trim(sizee);

            const inventory_details = inventoryJSON[temp_val];
            const inventory = parseInt(inventory_details.inventory);
          const available = inventory_details.available;
            const option_label_element = $(this).find('.z_products_size_value_label');
            const status_element = $(this).find(".dm_products_size_value_status");
            const notify_element = $(this).find('.dm_products_size_value_notice');

          console.log(inventory, available,option_label_element,status_element ,notify_element)

            if (inventory < 5 && inventory > 0) {
                $(notify_element).text(`Hurry, only ${inventory} left`);
            } else {
                $(notify_element).text("");
            }

            if (!available && inventory === 0) {
              $(status_element).text("Out of Stock");
                $(option_label_element).parent('.dm_products_size_value_option').addClass("dm_product_main_sold_out");
            } else {
              // console.log($('#custId').val());
              if (available && inventory <= 0){
   $(status_element).text($('#custId').val());
              }else{
                   $(status_element).text("Available");
              }
              
              console.log()
                $(option_label_element).parent('.dm_products_size_value_option').removeClass("dm_product_main_sold_out");
            }


        });

      // const p_id = $(this).closest(".dm_main_collection_product").attr("p_id");

      

      //   const options_arr = $('.z_drawer_collection[p_id="'+ p_id +'"]').find(".dm_products_size_value_option");

      // const product_id = tthiss.attr('data-product-id')

      //  const inventoryJSONElement = $(this).closest(".dm_main_collection_product").find(".custom_variant_quantity--" + product_id);
      //   const inventoryJSON = $.parseJSON(inventoryJSONElement.text());

      //   options_arr.each(function() {
      //       let size_path = $(this);
      //       let sizee = $(this).find(".dm_products_size_value_name").text();
      //       let temp_val = $.trim(selected_var) + " / " + $.trim(sizee);

      //     onst inventory_details = inventoryJSON[temp_val];
      //       const inventory = parseInt(inventory_details.inventory);
      //     const available = inventory_details.available;
      //       const option_label_element = $(this).find('.z_products_size_value_label');
      //       const status_element = $(this).find(".dm_products_size_value_status");
      //       const notify_element = $(this).find('.dm_products_size_value_notice');
          
      //       tthiss.find(".dm_product_variants .dm_swatch option").each(function(i) {
      //           console.log($(this).attr("data-policy"),
      //                        $(this).attr("data-size"));
      //           if ($(this).text().trim() == temp_val) {
      //               if ($(this).attr("data-policy") == 'deny' && $(this).attr("data-size") <= 0) {
      //                   size_path.find("label").css("pointer-events", "none");
      //                   size_path.find(".dm_products_size_value_label_parent").addClass("z_product_ui_option_un");
      //                   size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Sold out")
      //               } else {
      //                   size_path.find("label").css("pointer-events", "all");
      //                   size_path.find(".dm_products_size_value_label_parent").removeClass("z_product_ui_option_un");
      //                   size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Available")
      //               }
      //           }
      //       })
      //   });

    });

    $("body").on("click", ".z_main_product_button_size", function() {

        let m_id = $(this).closest(".dm_main_collection_product").attr("p_id");
        let selected_var = $(this).closest(".dm_main_collection_product").find(".dm_main_product_value_input:checked").attr("option-value");

        let tthiss = $(this).closest(".dm_main_collection_product");

        $(".z_product_drawer").find(".z_drawer_collection").each(function() {
            if ($(this).attr("p_id") == m_id) {
                $(this).find(".dm_products_size_value_option").each(function() {
                    let size_path = $(this);
                    let sizee = $(this).find(".dm_products_size_value_name").text();
                    let temp_val = selected_var + " / " + sizee;

                    tthiss.find(".dm_product_variants .dm_swatch option").each(function(i) {
                        if ($(this).text().trim() == temp_val) {
                            if ($(this).attr("data-size") == 0) {
                                size_path.find("label").css("pointer-events", "none");
                                size_path.find(".dm_products_size_value_label_parent").addClass("z_product_ui_option_un");
                                size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Sold out")
                            }
                        }
                    })
                })
                $(this).find(".dm_products_size_overlay").addClass("dm_products_size_overlay_e");
                $(this).find(".dm_products_size").addClass("z_open");
                // $("body").addClass("dm_products_size_hidden");
            }
        })
    })

    $("body").on("click", "#ProductGridContainer .dm_products_size_overlay", function() {
        $(this).closest(".z_collection_dyn").find(".dm_products_size_overlay").removeClass("dm_products_size_overlay_e");
        $(".dm_products_size").removeClass("z_open");
        $("body").removeClass("dm_products_size_hidden");
    })

    $("body").on("click", "#ProductGridContainer .dm_products_size_close", function() {
        $(this).closest(".z_collection_dyn").find(".dm_products_size_overlay").removeClass("dm_products_size_overlay_e");
        $(".dm_products_size").removeClass("z_open");
        $("body").removeClass("dm_products_size_hidden");
    })

    $("body").on("click", ".dm_main_product_value_image", function() {
        let src = $(this).find("img:first-child").attr("src");
        $(this).closest(".dm_main_collection_product").find(".dm_main_product_image img").attr("src", src);
        let quantity = $(this).attr("data-quantity");
        if (quantity == 0) {
            $(this).closest(".dm_main_collection_product").find(".dm_main_product_button_adc").css({
                "pointer-events": "none",
                "opacity": "0.5"
            })
        } else {
            $(this).closest(".dm_main_collection_product").find(".dm_main_product_button_adc").css({
                "pointer-events": "all",
                "opacity": "1"
            })
        }
    })
    //    $("body").on("click",".z_main_product_button_size", function(){
    // $(".dm_main_collection_product").each(function(){
    //   let tthiss = $(this)
    //   let clr_text = $(this).find(".dm_main_product_variant_title .dm_main_product_variant_title_e").text().trim();
    //   console.log("clr_text" , clr_text)
    //   let pro_id = $(this).attr("p_id");
    //   $(".z_product_drawer").find(".z_drawer_collection").each(function(i){
    //     let d_id = $(this).attr("p_id");
    //     if(d_id  == pro_id){
    //       $(this).find(".dm_products_size_value_option").each(function(){
    //         let size_path = $(this);
    //         let sizee = $(this).find(".dm_products_size_value_name").text();
    //         let temp_val = clr_text + " / " + sizee;
    //         console.log("temp_val" , temp_val)
    //         console.log("tthiss" , tthiss)
    //         tthiss.find(".dm_product_variants .dm_swatch option").each(function(i){
    //           if($(this).text().trim() == temp_val){
    //             if($(this).attr("data-size") == 0){
    //               size_path.find("label").css("pointer-events", "none");
    //               size_path.find(".dm_products_size_value_label_parent").addClass("z_product_ui_option_un");
    //               size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Sold out")
    //             }
    //           }
    //         })
    //       })
    //     }
    //   })
    // })
    //     })

    // $("body").on("change" , ".dm_main_product_value_input",function(){
    //   console.log("change")
    //   let clr_text;  
    //   clr_text = $(this).attr("option-value");
    //   let tthiss = $(this).closest(".dm_main_collection_product");
    //   console.log("clr_text" , clr_text)
    //   let pro_id = $(this).closest(".dm_main_collection_product").attr("p_id");
    //   console.log("pr" , pro_id)
    //   $(".z_product_drawer").find(".z_drawer_collection").each(function(){
    //     let d_id = $(this).attr("p_id");
    //     console.log("d_id" , d_id)
    //     if(d_id  == pro_id){
    //       $(this).find(".dm_products_size_value_option").each(function(){
    //         let size_path = $(this);
    //         let sizee = $(this).find(".dm_products_size_value_name").text();
    //         console.log("sizee", sizee)
    //         let temp_val = clr_text + " / " + sizee;
    //         console.log("temp_val" , temp_val)
    //         console.log("tthiss" , tthiss)
    //         tthiss.find(".dm_product_variants .dm_swatch option").each(function(i){
    //           if($(this).text().trim() == temp_val){
    //             if($(this).attr("data-policy")== 'deny' &&  $(this).attr("data-size") <= 0){
    //               size_path.find("label").css("pointer-events", "none");
    //               size_path.find(".dm_products_size_value_label_parent").addClass("z_product_ui_option_un");
    //               size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Sold out")
    //             }
    //             else{
    //               size_path.find("label").css("pointer-events", "all");
    //               size_path.find(".dm_products_size_value_label_parent").removeClass("z_product_ui_option_un");
    //               size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Available")
    //             }
    //           }
    //         })
    //       })
    //     }
    //   })
    // })
    $("body").on("click", ".z_main_product_button_size", function() {
      e.preventDefault();
  e.stopPropagation();
  console.log("CLICK: only once now");

      let selected_var = $(this).closest(".dm_main_collection_product").find(".dm_main_product_value_input:checked").attr("option-value");
        let tthiss = $(this).closest(".dm_main_collection_product");
      
        const selected_size_options = $(this).closest(".dm_main_collection_product")
        const url_product = selected_size_options.data('product-url');
        const product_id = selected_size_options.data('product-id');

        const inventoryJSONElement = $(this).closest(".dm_main_collection_product").find(".custom_variant_quantity--" + product_id);
        const inventoryJSON = $.parseJSON(inventoryJSONElement.text());

        const bottom_option_arr = $(`.z_product_drawer .dm_products_size[data-product-id="${product_id}"] .dm_products_size_value .dm_products_size_value_option`);
console.log("FULL INVENTORY JSON:", inventoryJSON);
 

        bottom_option_arr.each(function() {
            let size_path = $(this);
            let sizee = $(this).find(".dm_products_size_value_name").text();
            let temp_val = $.trim(selected_var) + " / " + $.trim(sizee);
console.log("TEMP VAL:", temp_val);
            const inventory_details = inventoryJSON[temp_val];
            console.log(inventory_details);
            const inventory = parseInt(inventory_details.inventory);
          const available = inventory_details.available;
            const option_label_element = $(this).find('.z_products_size_value_label');
            const status_element = $(this).find(".dm_products_size_value_status");
            const notify_element = $(this).find('.dm_products_size_value_notice');



console.log("CHECK KEY:", temp_val, " → ", inventoryJSON[temp_val]);
console.log("ALL KEYS:", Object.keys(inventoryJSON));


            if (inventory < 5 && inventory > 0) {
                $(notify_element).text(`Hurry, only ${inventory} left`);
            } else {
                $(notify_element).text("");
            }

            if (!available && inventory === 0) {
              $(status_element).text("Out of Stock");
                $(option_label_element).parent('.dm_products_size_value_option').addClass("dm_product_main_sold_out");
            } else {
              // console.log($('#custId').val());
              if (available && inventory <= 0){
   $(status_element).text($('#custId').val());
              }else{
                   $(status_element).text("Available");
              }
              
              console.log()
                $(option_label_element).parent('.dm_products_size_value_option').removeClass("dm_product_main_sold_out");
            }


        });
        /* $(".dm_color_active").each(function(){
           let e_clr_text;
           e_clr_text = $(this).attr("option-value");
           let e_tthiss = $(this).closest(".dm_main_collection_product");
           let e_pro_id = $(this).closest(".dm_main_collection_product").attr("p_id");
           $(".z_product_drawer").find(".z_drawer_collection").each(function(){
             let e_d_id = $(this).attr("p_id");
             if(e_d_id  == e_pro_id){
               $(this).find(".dm_products_size_value_option").each(function(){
                 let e_size_path = $(this);
                 let e_sizee = $(this).find(".dm_products_size_value_name").text();
                 let e_temp_val = e_clr_text + " / " + e_sizee;
                 e_tthiss.find(".dm_product_variants .dm_swatch option").each(function(i){
                   if($(this).text().trim() == e_temp_val){
                     if($(this).attr("data-policy")== 'deny' &&  $(this).attr("data-size") <= 0){
                       e_size_path.find("label").css("pointer-events", "none");
                       e_size_path.find(".dm_products_size_value_label_parent").addClass("z_product_ui_option_un");
                       e_size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Sold out")
                     }
                     else{
                       e_size_path.find("label").css("pointer-events", "all");
                       e_size_path.find(".dm_products_size_value_label_parent").removeClass("z_product_ui_option_un");
                       e_size_path.find(".dm_products_size_value_label_parent .dm_products_size_value_status").text("Available")
                     }
                   }
                 })
               })
             }
           })
          */
    })
})